
export function isEnumValue<TEnum extends Record<string, string | number>>(
  enumObj: TEnum,
  value: unknown
): value is TEnum[keyof TEnum] {
  return Object.values(enumObj).includes(value as TEnum[keyof TEnum]);
}